/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Author/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Author({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/InfoDialog/Content/AppointmentNotes/Content/AppointmentNoteText/Author"
  
}) {
let noteAuthorUserPersonFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'note',
path: 'author_user.person.first_name',
})
let noteAuthorUserPersonLastNameValueData = fromData.useDataValue({ viewPath,
context: 'note',
path: 'author_user.person.last_name',
})
let aggregateData = fromAggregate.join(noteAuthorUserPersonFirstNameValueData, noteAuthorUserPersonLastNameValueData)
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral800}
 weight="medium"
 size="small"
 noTitle={true}
 marginTop={dtSpaceXs}
 data="note.author_user.person.first_name"
 data="note.author_user.person.last_name"
 aggregate="/Data/aggregate join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}